import { useRef, useState } from 'react';
import { useFormik } from 'formik';
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';

import { ModelOfFuelType } from '../../database/index';

import api from '../../services/api';
import { useAuth } from 'src/contexts/auth';
import { AxiosResponse } from 'axios';

export const useFormCreateFuelType = () => {
	const { userAgencyId } = useAuth();
	const [loading, setLoading] = useState<boolean>(false);
	const [fuelResponse, setFuelResponse] = useState<AxiosResponse | null>(null);
	const [fuelEditedResponse, setFuelEditedResponse] = useState<AxiosResponse | null>(null);
	const history = useHistory();

	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		DESCRICAO: Yup.string().required('* Campo obrigatório'),
	});

	const saveFuelType = async (fueltype: ModelOfFuelType) => {
		setLoading(true);

		const newFuelType: ModelOfFuelType = {
			...fueltype,
			ORGAO: userAgencyId,
		};

		if (!!fuelResponse) {
			api.put(`fuels/${fuelResponse.data.ID}`, newFuelType)
				.then((response) => {
					formik.resetForm();
					setFuelEditedResponse(response);
					setFuelResponse(null);
					setLoading(false);
					toast.current.show({
						severity: 'success',
						summary: 'Edição realizada',
						detail: 'O tipo de combustível foi editada com sucesso!',
						life: 5000,
					});
				})
				.catch((err) => {
					console.log(err);
					setLoading(false);
					toast.current.show({
						severity: 'error',
						summary: 'Edição não realizado',
						detail: 'Falha ao realizar operação!',
						life: 5000,
					});
				});
		} else {
			api.post('fuels', newFuelType)
				.then((response) => {
					if (window.location.href === '/fueltypeForm') history.push('/listFueltypes');
					setLoading(false);
					setFuelResponse(response);
					toast.current.show({
						severity: 'success',
						summary: 'Cadastro realizado',
						detail: 'Operação realizada com sucesso!',
						life: 5000,
					});
				})
				.catch((err) => {
					setLoading(false);
					toast.current.show({
						severity: 'error',
						summary: 'Cadastro não realizado',
						detail: 'Falha ao realizar operação!',
						life: 5000,
					});
				});
		}
	};

	const formik = useFormik<ModelOfFuelType>({
		initialValues: {
			ORGAO: '',
			DESCRICAO: '',
		},
		onSubmit: async (values) => await saveFuelType(values),
		validationSchema,
	});

	return {
		getFuelFormController: {
			formik,
			loading,
			toast,
			fuelResponse,
			fuelEditedResponse,
		},
		handleFuelFormController: {
			setFuelResponse,
			setFuelEditedResponse,
		},
	};
};
